export default "__VITE_ASSET__DldKjkaH__"